<template>
    <div class="contract-summary">
        <div class="contract-summary__item">
            <span v-text="'Data zawarcia:'" class="contract-summary__label" />
            <div class="contract-summary__value">
                <a-icon icon="Calendar" class="text-orange" />
                {{ startDate }}
            </div>
        </div>

        <div class="contract-summary__item">
            <span v-text="'Data zakończenia:'" class="contract-summary__label" />
            <div class="contract-summary__value">
                <a-icon icon="Calendar" class="text-orange" />
                {{ endDate }}
            </div>
        </div>

        <div class="contract-summary__item">
            <span v-text="'Status umowy:'" class="contract-summary__label" />
            <div class="contract-summary__value">
                <span
                    v-if="status"
                    v-tooltip="status.tooltip"
                    class="status w-100"
                    :class="status.class"
                >
                    <span v-text="status.text" />
                    <a-icon v-if="status.tooltip" icon="Info" />
                </span>
                <span v-else v-text="'---'" />
            </div>
        </div>

        <div class="contract-summary__item">
            <span class="contract-summary__label">
                Sklepy:
                <a-icon
                    v-tooltip="'Liczba sklepów objętych umową'"
                    height="16"
                    icon="Info"
                />
            </span>
            <div class="contract-summary__value">
                <a-icon icon="Shop" class="text-orange" />
                {{ activeSubsAmount }}
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { CONTRACT_STATUSES, CONTRACT_LOCATION_STATUSES } from '@/utils/constants/drs/operators'

export default {
    computed: {
        ...mapGetters('drsOperators', ['operatorContract']),

        startDate() {
            return this.operatorContract.startDate ? moment(this.operatorContract.startDate).format('DD-MM-YYYY') : '---'
        },

        endDate() {
            if (
                (this.operatorContract.status === CONTRACT_STATUSES.ACTIVE ||
                this.operatorContract.status === CONTRACT_STATUSES.INCOMPLETE) &&
                !this.operatorContract.endDate
            ) {
                return 'czas nieokreślony'
            }

            return this.operatorContract.endDate ? moment(this.operatorContract.endDate).format('DD-MM-YYYY') : '---'
        },

        status() {
            switch (this.operatorContract.status) {
            case CONTRACT_STATUSES.INCOMPLETE:
                return {
                    class: 'is-warning',
                    text: 'Niekompletna',
                    tooltip: ' Edytuj umowę, zaznacz sklepy objęte umową,<br/>wprowadź numery punktów zbiórki i zapisz wprowadzone dane'
                }
            case CONTRACT_STATUSES.ACTIVE:
                return { class: 'is-success', text: 'Aktywna' }
            case CONTRACT_STATUSES.ARCHIVED:
                return { class: 'is-secondary', text: 'Zarchiwizowana' }
            case CONTRACT_STATUSES.NOT_REGISTERED:
            default:
                return null
            }
        },

        activeSubsAmount() {
            return this.operatorContract.subscriptions
                .filter(loc => loc.locStatus !== CONTRACT_LOCATION_STATUSES.INACTIVE).length
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.contract-summary {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    background-color: var(--color-white);
    border-radius: 4px;
    border: 1px solid var(--color-gray-300);

    @include media-breakpoint-down(md) {
        grid-template-columns: repeat(2, 1fr);
    }

    @include media-breakpoint-down(xs) {
        grid-template-columns: 1fr;
    }

    &__item {
        display: grid;
        grid-template-rows: auto 1fr;
        gap: 0.5rem;
        padding: 1.5rem;
        text-align: center;
        justify-content: center;
        position: relative;

        &:not(:first-child)::before {
            content: '';
            position: absolute;
            top: 1rem;
            left: 0;
            bottom: 1rem;
            border-left: 1px solid var(--color-gray-200);
        }

        @include media-breakpoint-down(xs) {
            &:not(:first-child)::after {
                content: '';
                position: absolute;
                left: 1.5rem;
                right: 1.5rem;
                border-bottom: 1px solid var(--color-gray-200);
            }

            &::before {
                display: none;
            }
        }
    }

    &__label {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.25rem;
        color: var(--color-primary);
    }

    &__value {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        min-width: 10rem;
        color: var(--color-dark);
    }
}
</style>
